import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Component from "components/component";
import mapDispatchToProps from "lib/map-dispatch-to-props";
import { childrenShape } from 'lib/shapes';
import * as configuratorActions from "../../actions/configurator-actions";

const Wrapper = ({ children, plain }) => {
  if (plain) return <div>{children}</div>;

  return (
    <div className="product-options-row configurator-action-buttons-wrapper">
      <div className="configurator-action-buttons">
        {children}
      </div>
    </div>
  );
};

Wrapper.propTypes = {
  children: childrenShape.isRequired,
  plain: PropTypes.bool.isRequired,
};

class ConfiguratorActionButtons extends Component {
  static propTypes = {
    buttonClass: PropTypes.string,
    clientId: PropTypes.string,
    creatingProject: PropTypes.bool.isRequired,
    isEditing: PropTypes.bool.isRequired,
    lineItemId: PropTypes.string,
    openModal: PropTypes.func.isRequired,
    plain: PropTypes.bool,
    projectUpdating: PropTypes.bool.isRequired,
    updateProjectItem: PropTypes.func.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    saveState: PropTypes.func
  };

  static defaultProps = {
    plain: false,
  };

  assignItemToProject = e => {
    e.preventDefault();
    this.props.openModal("choose-projects");
  };

  openWhatsThis = e => {
    e.preventDefault();
    this.props.openModal("whats-this");
  };

  openLogin = e => {
    this.props.actions.configuratorActions.saveState();
    e.preventDefault();
    this.props.openModal("login");
  };

  updateProjectItem = e => {
    e.preventDefault();
    this.props.updateProjectItem(this.props.lineItemId, this.props.clientId);
  };

  render() {
    const { buttonClass, creatingProject, isEditing, plain, projectUpdating, userRole } = this.props;
    const isRetailUser = userRole === 'retail_user';

    return (
      <Wrapper plain={plain}>
        {this.props.isLoggedIn ? (
          <>
            {isEditing && (
              <button
                onClick={this.updateProjectItem}
                disabled={projectUpdating}
                className={buttonClass ? buttonClass : "large right"}
              >
                {projectUpdating ? "Updating Project.." : "Update"}
              </button>
            )}

            {!isEditing && (
              <button
                disabled={creatingProject || isRetailUser}
                onClick={this.assignItemToProject}
                className={buttonClass ? buttonClass : "large right"}
              >
                {creatingProject ? "Adding..." : "Save Quote"}
              </button>
            )}
          </>
        ) : (
          <button
            onClick={this.openLogin}
            className={buttonClass ? buttonClass : "large right"}
          >
            Save Quote
          </button>
        )}
      </Wrapper>
    );
  }
}

function mapStateToProps(_state) {
  return {};
}

export default connect(
  mapStateToProps,
  mapDispatchToProps(configuratorActions)
)(ConfiguratorActionButtons);
